import React, { Suspense, lazy } from "react";

import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { createBrowserHistory } from "history";
import { Route, Router, Switch } from "react-router-dom";

import Loader from "./Util/Loader/Loader";

import ReactGA from "react-ga4";

import "./App.css";
// import Error from "./Util/Error/Error";

const Home = lazy(() =>
  import(/* webpackChunkName: "Home" */ "./Home/Home.js")
);

const Success = lazy(() =>
  import(/* webpackChunkName: "Success" */ "./Success/Success.js")
);

const Failed = lazy(() =>
  import(/* webpackChunkName: "Failed" */ "./Failed/Failed.js")
);

const Ticket = lazy(() =>
  import(/* webpackChunkName: "Ticket" */ "./Ticket/Ticket.js")
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF891C",
    },
    secondary: {
      main: "#222222",
    },
  },
  // typography: {
  //   fontFamily: ["-apple-system", "Outfit", "sans-serif"].join(","),
  // },
});

//
// GTag measurement ID

// export const formatPrice = (price) => {
//   return new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//   }).format(price);
// };

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    ReactGA.initialize("G-RSC1S3DEEG");
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/success/:ticketId" component={Success} />
              <Route path="/failed" component={Failed} />
              <Route path="/ticket/:ticketId" component={Ticket} />
              <Route component={Home} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
